import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-prasiddhi-patrak-list',
    templateUrl: './prasiddhi-patrak-list.component.html',
    styleUrl: './prasiddhi-patrak-list.component.scss'
})
export class PrasiddhiPatrakListComponent {
    rcv_amt: any;
    advt_amt: any;


    constructor(
        private dialogRef: MatDialogRef<PrasiddhiPatrakListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService,
        private cdr: ChangeDetectorRef,
        private fb: FormBuilder
    ) { }



    Address: any;
    pincode: any;
    name: any;
    issuenamenew: any;
    cust_name: any;
    issuedatepp: any;
    val: any;
    advt_name: any;
    rep_name: any;
    off_rep_name: any;
    issue_category: any;
    issue_dates: any;
    issue_date: string;
    issue_name: any;
    today: Date;
    district: any;
    taluka: any;
    modetype: any;
    start_date: any;
    end_date: any;
    prantname: any;
    country: any;
    state: any;
    duration: any;
    currentDate = new Date();


    ngOnInit(): void {
        debugger;
        this.issuenamenew = this.data['issuenamenew'];
        this.rcv_amt = this.data['rcv_amt'];
        this.advt_amt = this.data['advt_amt'];
        this.cust_name = this.data['cust_name'];
        this.issuedatepp = this.data['issuedatepp'];
        this.start_date = this.data['start_date'];
        this.end_date = this.data['end_date'];
        this.val = this.data['val'];
        this.district = this.data['district'];

        this.advt_name = this.data['advt_name'] || '';
        this.rep_name = this.data['rep_name'] || '';
        this.off_rep_name = this.data['off_rep_name'] || '';
        this.issue_category = this.data['issue_category'] || '';
        this.issue_dates = this.data['issue_date'] || '';

        this.issue_date = this.data['issue_date'] + '';
        if (this.issue_date.includes(',')) {
            [this.issue_date, this.issue_name] = this.issue_date.split(',');
        }
        this.today = new Date();

        this.getAllAdd(this.val);
    }

    getAllAdd(val: any) {
        const req = {
            'value': val,
            'issue_name': this.issue_category,
            'issue_date': this.issue_dates,
            'start_date': this.start_date,
            'end_date': this.end_date,
            'advt_name': this.advt_name,
            'rep_name': this.rep_name,
            'off_rep_name': this.off_rep_name

        }

        console.log(req, "new all address");

        this.service.getAllAdd(req).subscribe(
            (data: any) => {
                console.log("pending add=", data);
                this.Address = data;
            },
            (error) => {
                console.error("Error fetching addresses:", error);
            }
        );

        console.log("req 2 for add", req);
    }

    show = false;

    printPageA4Portrait() {
        this.show = true;
        const printSection = document.getElementById('print-section');
        if (!printSection) {
            console.error("Print section not found!");
            return;
        }

        const printContent = printSection.innerHTML;

        const screenWidth = window.screen.availWidth;
        const windowWidth = 1200; // Increased window width
        const leftPosition = screenWidth - windowWidth - 50;

        const printWindow = window.open('', '', `width=${windowWidth},height=900,top=50,left=${leftPosition},scrollbars=yes`);

        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            margin: 0;
                            padding: 10px;
                            font-size: 14px;
                        }
                        
                        /* Common styles for both screen and print */
                        .press-release-container {
                            width: 100%;
                            max-width: none;
                            margin: 0 auto;
                            padding: 0;
                        }
                        
                        .header {
                            text-align: center;
                            margin-bottom: 20px;
                            border-bottom: 2px solid #000;
                            padding-bottom: 10px;
                        }
                        
                        .header-title {
                            font-size: 24px;
                            font-weight: bold;
                            margin-bottom: 10px;
                        }
                        
                        .header-info {
                            display: flex;
                            justify-content: space-between;
                            font-size: 16px;
                            margin-bottom: 10px;
                        }
                        
                        .header-info span {
                            flex: 1;
                            text-align: center;
                        }
                        
                        .divider {
                            border-bottom: 1px solid #000;
                            margin: 10px 0;
                        }
                        
                        /* Auto-fit columns as per data */
.address-table {
    width: 100%;
    border-collapse: collapse !important;
    table-layout: auto !important;  /* 👈 KEY: allows natural column sizing */
    font-size: 14px;
    border: 2px solid #333 !important;
    margin-top: 10px;
}

.address-table th,
.address-table td {
    border: 1px solid #333 !important;
    padding: 8px 10px !important;
    vertical-align: middle;
    text-align: left;
    white-space: nowrap; /* keep data in one line */
}

.address-table th {
    background-color: #f8f9fa !important;
    font-weight: bold;
    text-align: center;
    font-size: 15px;
}

/* Individual column alignments — no width defined */
.address-table th:nth-child(1),
.address-table td:nth-child(1) {
    text-align: left !important;
    padding-left: 10px !important;
}

.address-table th:nth-child(2),
.address-table td:nth-child(2) {
    text-align: left !important;
    padding-left: 10px !important;
}

.address-table th:nth-child(3),
.address-table td:nth-child(3) {
    text-align: center !important;
}

.address-table th:nth-child(4),
.address-table td:nth-child(4),
.address-table th:nth-child(5),
.address-table td:nth-child(5) {
    text-align: right !important;
    font-weight: bold;
    padding-right: 10px !important;
}

                        
                        /* Print specific styles */
                        @media print {
                            @page {
                                size: A4 portrait;
                                margin: 10mm;
                            }
                            
                            body {
                                font-size: 12px !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            
                            .address-table {
                                font-size: 12px !important;
                                page-break-inside: auto;
                            }
                            
                            .address-table th,
                            .address-table td {
                                padding: 6px !important;
                                font-size: 12px !important;
                                line-height: 1.1;
                            }
                            
                            thead {
                                display: table-header-group !important;
                            }
                            
                            tr {
                                page-break-inside: avoid;
                                page-break-after: auto;
                            }
                            
                            .noPrint {
                                display: none !important;
                            }
                        }
                        
                        /* Screen specific styles */
                        @media screen {
                            .press-release-container {
                                padding: 20px;
                                background: white;
                                box-shadow: 0 0 10px rgba(0,0,0,0.1);
                                margin: 20px auto;
                                max-width: 1200px; /* Increased max-width for screen */
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="press-release-container">
                        ${printContent}
                    </div>
                    <script>
                       window.onload = function () {
                           const table = document.querySelector('.address-table');
                           if (!table) {
                               console.error("Table not found");
                               return;
                           }

                           // Ensure table structure
                           let thead = table.querySelector('thead');
                           if (!thead) {
                               thead = document.createElement('thead');
                               table.insertBefore(thead, table.firstChild);
                           }

                           // Find and move header rows to thead
                           const rows = Array.from(table.querySelectorAll('tr'));
                           rows.forEach((row, index) => {
                               const cells = Array.from(row.cells);
                               const cellTexts = cells.map(cell => cell.textContent.trim());
                               
                               // Check if this is a header row
                               if (cellTexts.includes('पत्ता यादी') || 
                                   cellTexts.includes('जहिरातदार नाव') ||
                                   cells.some(cell => cell.tagName === 'TH')) {
                                   if (row.parentNode !== thead) {
                                       thead.appendChild(row);
                                   }
                               }
                           });

                           // Apply alignment and formatting
                           const cells = document.querySelectorAll('td, th');
                           cells.forEach(cell => {
                               const content = cell.textContent.trim();
                               
                               // Right align amounts and numbers
                               if (content.includes('रक्कम') || 
                                   /^\d+(\.\d+)?$/.test(content) ||
                                   content.includes('येणे')) {
                                   cell.style.textAlign = 'right';
                               }
                               
                               // Center align mobile numbers and location
                               if (content.includes('संपर्क क्रमांक') || 
                                   content.includes('ठिकान') ||
                                   /^\d{10}$/.test(content)) {
                                   cell.style.textAlign = 'center';
                               }
                           });

                           setTimeout(() => {
                               window.print();
                               setTimeout(() => { window.close(); }, 500);
                           }, 300);
                       };
                    </script>
                </body>
            </html>
        `);
            printWindow.document.close();
        } else {
            console.error("Failed to open print window.");
        }
    }










}
